angular.module('ui2.0Controllers').controller('contractsBulkEditController', ['$scope', '$uibModal', 'entityFactory', '$rootScope', '$location', '$templateCache', '$compile', '$timeout', '$http', '$window', '$anchorScroll', 'urlFactory', '$routeParams', '$sce', '$document', '$route', '$filter', '$q', 'showPageService', function ($scope, $modal, entityFactory, $rootScope, $location, $templateCache, $compile, $timeout, $http, $window, $anchorScroll, urlFactory, $routeParams, $sce, $document, $route, $filter, $q, $showPageService) {
    $scope.globalData = {dateFormatToShow: SirionUtils.getDateFormat()};
    SirionUtils.setUpCommonPicker.call($scope, 'effectiveDelegationStartDate', "", false, false);
    SirionUtils.setUpCommonPicker.call($scope, 'effectiveDelegationEndDate', "", false, false);
    $scope.masterData = {data: []};
    $scope.docIds = [];
    $scope.bulkSharedDropDwn = [];
    $scope.bulkExtractDropDwn = [];
    $scope.singleSharedBulkValue = null;
    $scope.singleExtractBulkValue = null;
    const contractDocTableScope = $('#table_3910').scope();
    $scope.hasDocumentTagEditAccess = $scope.metaData?.properties?.["hasDocumentTagEditAccess"]; // delete or add 
    $scope.documentTagsEnabled = $scope.metaData?.properties?.["documentTagsEnabled"]; // show document tag column
    const entityType = SirionUtils.appendTblToUrl(SirionUtils.getEntityTypeFromUrl());
    const entityListId = _.get(urlToEntityDataMapper,`[${entityType}].listId`);
    $scope.optionDocumentTagUrl=`/options/155?pageType=1&entityTpeId=317&parentEntityId=&pageEntityTypeId=${urlToCodeMapper[entityType]}&fieldId=&filterId=534&offset=0&listId=${entityListId}`;
    $scope.selectedTag = {
        name: 'Append',
        id: 2,
    };
    $scope.sharedWithChckBox = {
        value: false
    }
    $scope.extractChckBox = {
        value: false
    }
    let url = window.location.href
    $scope.finalId = url.substr(url.lastIndexOf('/') + 1).split('?')[0];
    $scope.selectedDocTags = [];
    const endpoint = "/contractDocument/bulkEditLayout";
    // const dataToPost = dataManipulationService.getExtractionDataPoJo.call(scope, attrs.fieldid);
    $http.get(endpoint).then(function (resp) {
        $scope.masterData = {data: resp.data.fieldList};
        resp.data.fieldList.map(item => {
            if (item.id == 2) {
                $scope.bulkSharedDropDwn = item.data
            } else if (item.id == 1) {
                $scope.bulkExtractDropDwn = item.data

            }
        })
        let selectValue = {value: null, label: 'Select'}
        $scope.bulkSharedDropDwn.unshift(selectValue);
        $scope.bulkExtractDropDwn.unshift(selectValue);
        $scope.singleSharedBulkSelect = $scope.bulkSharedDropDwn[0];
        $scope.singleExtractBulkSelect = $scope.bulkExtractDropDwn[0]
    }).catch(error => window.systemWarning(error));

    $scope.selectAction = (event,value) => {
        event.stopPropagation();
        $scope.selectedTag = _.clone(value);
    }

    $scope.selectFromDropDwn = (item, fromShared) => {
        if (fromShared) {
            $scope.singleSharedBulkValue = item.value;
        } else {
            $scope.singleExtractBulkValue = item.value;
        }
    }

    $scope.addBulkTag = function(val){
        startLoader();
        const endPoint = addtStamp(`/documenttag/v2/create/${$scope.entityTypeId || urlToCodeMapper[entityType]}`);
        const dataToPost = {name: val};
        $timeout(()=> {
            $http.post(endPoint, dataToPost).then(function (res) {

                if (_.get(res, 'data.response.id')) {
                    Toaster.create(intl_msg[21076]);
                } else if (_.get(res, 'data.errors.length')) {
                    Toaster.create(_.get(res,"data.errors[0].message") || intl_msg[21077],{iconClass:"icon-Information_filled"});
                } else {
                    Toaster.create(intl_msg[6462], {iconClass: "icon-Information_filled"});
                }
                $scope.$broadcast('clearSearchVal');
                $scope.$broadcast('closeMsDD');
                stopLoader();

            }, function (err) {
                toggleServerErrorNotification(true);
                stopLoader();
            })
        }, 300)
    }

    $scope.deleteDocumentTag = (e, option, openDialog) => {
        if(openDialog){
            const args = {
                popupType: 'confirm',
                str: "Deleting option will remove it from the dropdown list. Do you want to proceed?",
                heading: window.intl_msg[25772],
                yesCbFn: ()=> {
                    $scope.deleteDocumentTag(e, option, false);
                },
                noCbFn: () => {
                    window.SirionUtils.openSirionDialogs({
                        popupType: 'close'
                    })
                },
                yesName: 'Delete',
                noName: 'Cancel',
            }
            window.SirionUtils.openSirionDialogs(args);
            return;
        }
        const tagId = option.id
        const tagDeleteUrl = `/documenttag/v2/delete/${$scope.entityTypeId || urlToCodeMapper[entityType]}/${tagId}` 
        $http.delete(window.addtStamp(tagDeleteUrl)).then(function (res) {
            if (res.data && res.data.success) {
                Toaster.create("Tag Deleted Successfully");
            } else if(_.get(res,"data.errors.length")){
                Toaster.create(_.get(res,"data.errors[0].message"),{iconClass:"icon-Information_filled"});
            } else {
                Toaster.create(intl_msg[6462], {iconClass: "icon-Information_filled"});
            }
            $scope.$broadcast('clearSearchVal')
        }).catch(error => window.systemWarning(error));
    }
    $scope.updateFields = () => {
        startLoader();
        $scope.selectedDocTags && $scope.selectedDocTags.map(item => {
            $scope.docIds.push(item.id)
        })
        var dataToPost = {
            "documentIds": contractDocTableScope.selectedCheckBoxes,
            "entityId": $scope.data.id.values,
            "entityTypeId": 160,
            "fieldList": [
                {
                    "id": 1,
                    "name": "Extract Metadata",
                    "type": "select",
                    "data": $scope.singleExtractBulkValue,
                    "action": {
                        "name": "Update",
                        "id": 1
                    }
                },
                {
                    "id": 2,
                    "name": "SHARED WITH SUPPLIER",
                    "type": "select",
                    "data": $scope.singleSharedBulkValue,
                    "action": {
                        "name": "Update",
                        "id": 1
                    }
                },
                {
                    "id": 3,
                    "name": "Document Tags",
                    "type": "multiselect",
                    "data": $scope.docIds.join(),
                    "action": {
                        "name": $scope.selectedTag.name,
                        "id": $scope.selectedTag.id
                    }
                }
            ]
        }

        dataToPost.fieldList = dataToPost.fieldList.filter(function(field) {
            return $scope.masterData.data.some(function(item) { return field.id === item.id; });
        });


        var endpoint = "/contractDocument/performBulkEdit";
        $http.post(endpoint, dataToPost).then(function (resp) {
            stopLoader();
            if (resp.status == 200) {
                $scope.createContractsBulkEditModalInstance.close();
                $rootScope.$broadcast("refreshData", {dataURL: ('/listRenderer/list/367/tablistdata/160/' + $scope.finalId)});
                $rootScope.$emit("deselectSelections");
                contractDocTableScope.selectedCheckBoxes = []
                entityFactory.updateTabListingOnRequest(425);
                Toaster.create('Details updated successfully!', {iconClass: "icon-Success_Executed_Done"});
            } else {
                if (_.get(resp, 'data.error') && _.get(resp, 'data.error').length) {
                    Toaster.create(resp.data.error[0].message, {iconClass: "icon-Information_filled"});
                } else {
                    Toaster.create('Something went wrong!', {iconClass: "icon-Information_filled"});
                }
            }

        }, function (err) {
            stopLoader();
        })

    }

}]);
